import React from "react";

/**
 * Vertisiya wordmark — SVG "V" monogram with a sharp diagonal cut,
 * paired with the wordmark set in Geist. The monogram uses a chrome
 * gradient; the wordmark stays crisp white for legibility.
 */
export const Wordmark = ({ size = "md", showText = true, className = "" }) => {
  const px = size === "lg" ? 34 : size === "sm" ? 22 : 26;
  return (
    <div className={`inline-flex items-center gap-2.5 select-none ${className}`} aria-label="Vertisiya">
      <svg
        width={px}
        height={px}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <linearGradient id="v-chrome" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="55%" stopColor="#C9C9C9" />
            <stop offset="100%" stopColor="#6E6E6E" />
          </linearGradient>
          <linearGradient id="v-ember" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#E11D48" />
          </linearGradient>
        </defs>
        {/* outer notched square */}
        <path
          d="M2 2 H30 V22 L22 30 H2 Z"
          stroke="url(#v-chrome)"
          strokeWidth="1"
          fill="rgba(255,255,255,0.02)"
        />
        {/* V mark with a sharp diagonal cut */}
        <path
          d="M7 8 L16 22 L21.5 13.5 L25 8"
          stroke="url(#v-chrome)"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
        {/* accent dot */}
        <rect x="24" y="21" width="3" height="3" fill="url(#v-ember)" />
      </svg>
      {showText && (
        <span
          className="font-display text-[0.95rem] font-semibold tracking-tight lowercase text-white"
          style={{ letterSpacing: "-0.04em" }}
        >
          vertisiya
        </span>
      )}
    </div>
  );
};

export default Wordmark;
